import React from 'react';
import Confetti from 'react-confetti';

import classes from './MedDagen.module.css';

function MedDagen() {
  return (
    <>
      <div className={classes.medDagen}>
        <span className={classes.glow}>med dagen,</span>
        <br />
        <span className={classes.glow}>min kjære!</span> 😘
      </div>
      <Confetti
        numberOfPieces={2000}
        recycle={false}
        tweenDuration={10000}
        style={{ zIndex: 101 }}
      />
    </>
  );
}

export default MedDagen;
